import React from "react";
import { Modal, IconButton, Button as ButtonMUI } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import TextView from "../../TextView";
import Button from "../../Button";
import { ASSETS } from "../../../utils/config";
import { toast } from "react-toastify";

// Styled components
const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PopupContainer = styled.div`
  position: relative;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  padding: 26px;
  width: 90vw;
  max-width: 500px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

const Image = styled.img`
  width: 30%;
  height: auto;
`;

const Text = styled.p`
  margin: 20px 0;
`;

const Popup = ({ open, handleClose }) => {
  const copyToClipboard = () => {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        toast.success("URL copied to clipboard!");
        handleClose();
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };

  return (
    <StyledModal open={open} onClose={handleClose}>
      <PopupContainer>
        {/* <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton> */}
        <Image src={ASSETS.Wheely} alt="Popup Image" />
        <TextView variant="largeText">
          Welcome! For an optimal Wheel viewing experience please open on your
          desktop.
        </TextView>
        <TextView variant="text" style={{ textAlign: "center" }}>
          iOS users: Double tap segments to open.
        </TextView>
        <TextView variant="text" style={{ textAlign: "center" }}>
          Swipe up from segment title bar to expand content.
        </TextView>
        <Button style={{ width: "100%", height: 36 }} onClick={copyToClipboard}>
          Copy URL
        </Button>

        <ButtonMUI
          variant="outlined"
          onClick={handleClose}
          fullWidth
          sx={{
            borderColor: "#9B5AF8",

            color: "#9B5AF8",
            textTransform: "none",
            "&:hover": {
              borderColor: "#7F47D8",
              color: "#7F47D8",
            },
          }}
        >
          View on Mobile
        </ButtonMUI>
      </PopupContainer>
    </StyledModal>
  );
};

export default Popup;
